/**
 * Clock utility for managing mock time in development/testing
 * Allows setting a specific date as "today" for testing purposes
 */

const MOCK_NOW_KEY = 'mock-now';

/**
 * Get the current time, respecting any mock time setting
 */
export const getNow = (): Date => {
  const mockNow = localStorage.getItem(MOCK_NOW_KEY);
  if (mockNow) {
    const mockDate = new Date(mockNow);
    if (!isNaN(mockDate.getTime())) {
      return mockDate;
    }
    // If invalid mock date, clear it
    localStorage.removeItem(MOCK_NOW_KEY);
  }
  return new Date();
};

/**
 * Set a mock "now" time for testing
 * @param value - Date string (e.g., "2025-09-29") or undefined to clear
 */
export const setMockNow = (value?: string): void => {
  if (value) {
    const mockDate = new Date(value);
    if (isNaN(mockDate.getTime())) {
      console.error('Invalid mock date provided:', value);
      return;
    }
    localStorage.setItem(MOCK_NOW_KEY, mockDate.toISOString());
    console.info('🕐 Mock time set to:', mockDate.toDateString());
  } else {
    clearMockNow();
  }
};

/**
 * Clear any mock time setting
 */
export const clearMockNow = (): void => {
  localStorage.removeItem(MOCK_NOW_KEY);
  console.info('🕐 Mock time cleared, using real time');
};

/**
 * Check if mock time is currently active
 */
export const isMockNowActive = (): boolean => {
  return localStorage.getItem(MOCK_NOW_KEY) !== null;
};

// Debug logging when mock is active
if (isMockNowActive()) {
  console.debug('🕐 Mock time is active:', getNow().toDateString());
}